import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';
import { uploadFile, downloadFile, getPresignedUrlForZ3Url } from './z3-ext.js';

// AUTOGENERATED -- DO NOT EDIT
var _Z3_instances, _Z3_baseUrlThunk;
class Z3 extends SDKResource {
    constructor(config) {
        super(config);
        _Z3_instances.add(this);
        /**
         * Uploads a file to the bucket and key. Files should be Blobs.
         * @param params upload file params
         */
        this.uploadFile = uploadFile;
        /**
         * Downloads an object matching the bucket and key. File content is returned as an ArrayBuffer.
         * @param params download file params
         */
        this.downloadFile = downloadFile;
        /**
         * This helper performs a `getPresignedUrl` request for Z3 URLs of the forms
         * `https://projects-api.oystehr.com/v1/z3/<bucket>/<key>` or `z3://<bucket>/<key>`
         * instead of the standard SDK `Z3GetPresignedUrlParams`.
         * @param params url and action
         */
        this.getPresignedUrlForZ3Url = getPresignedUrlForZ3Url;
    }
    /**
     * List all Z3 Buckets. [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:ListBuckets`
     * Access Policy Resource: `Z3:BucketName`
     */
    listBuckets(request) {
        return this.request('/z3', 'get', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(request);
    }
    /**
     * Create a Z3 Bucket with the provided name. [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:CreateBucket`
     * Access Policy Resource: `Z3:*`
     */
    createBucket(params, request) {
        return this.request('/z3/{bucketName}', 'put', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Delete the Z3 Bucket with the provided name. [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:DeleteBucket`
     * Access Policy Resource: `Z3:BucketName`
     */
    deleteBucket(params, request) {
        return this.request('/z3/{bucketName}', 'delete', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * List all Z3 Objects at the provided path in the Bucket with the provided name [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:ListObjects`
     * Access Policy Resource: `Z3:BucketName:ObjectPath`
     */
    listObjects(params, request) {
        return this.request('/z3/{bucketName}/{objectPath+}', 'get', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Get a link for downloading or uploading a Z3 Object to the provided path in the Bucket with the provided name. [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:PutObject` or `Z3:GetObject`
     * Access Policy Resource: `Z3:BucketName:ObjectPath`
     */
    getPresignedUrl(params, request) {
        return this.request('/z3/{bucketName}/{objectPath+}', 'post', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Delete the Z3 Object at the provided path in the Bucket with the provided name. [Z3](https://docs.oystehr.com/oystehr/services/z3/) is Oystehr's built-in and fully integrated solution for file storage.
     *
     * Access Policy Action: `Z3:DeleteObject`
     * Access Policy Resource: `Z3:BucketName:ObjectPath`
     */
    deleteObject(params, request) {
        return this.request('/z3/{bucketName}/{objectPath+}', 'delete', __classPrivateFieldGet(this, _Z3_instances, "m", _Z3_baseUrlThunk).bind(this))(params, request);
    }
}
_Z3_instances = new WeakSet(), _Z3_baseUrlThunk = function _Z3_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { Z3 };
//# sourceMappingURL=z3.js.map
